import { Plural, Trans } from "@lingui/react/macro";

import { CropIcon } from "@/common/components/crop-icon/crop-icon";
import { currencyFormatter } from "@/common/services/formatter";
import { Currency } from "@/routes/shared/currency.params";

import { ThreeStepProgressBar } from "../progress-bar/progress-bar";

const numberFormatter = new Intl.NumberFormat(undefined);

const CommodityCard = ({ children }: React.PropsWithChildren) => {
  return (
    <article className="text-can-slate-blue-gray shadow-can-light-box flex flex-col gap-2 rounded-2xl p-4 text-xs">
      {children}
    </article>
  );
};

const Available = ({
  available,
  order,
  tons,
}: {
  order: number;
  available: number;
  tons: number;
}) => {
  const _available = numberFormatter.format(available);

  return (
    <p className="text-left">
      <Trans>
        K dispozici volných {_available} z{" "}
        <Plural
          _0="# tun"
          few="# tuny"
          many="# tun"
          one="# tuna"
          other="# tun"
          value={tons}
        />
        .
      </Trans>
      {order > 0 ? (
        <b className="text-[#FF914D]">
          {" "}
          <Trans>
            Aktivní příkazy na{" "}
            <Plural
              _0="# tun"
              few="# tuny"
              many="# tun"
              one="# tuna"
              other="# tun"
              value={order}
            />
            .
          </Trans>
        </b>
      ) : null}
    </p>
  );
};

const Stored = ({ tons = 0 }: { tons?: number }) => {
  return (
    <p className="text-left">
      <Trans>Skladem</Trans>:{" "}
      <Plural _0="# tun" few="# tuny" one="# tuna" other="# tun" value={tons} />
    </p>
  );
};

const Title = ({
  crop,
}: {
  crop: { harvestYear: number; name?: string; mark: boolean };
}) => (
  <h4 className="text-can-midnight-steel flex flex-wrap justify-between gap-2 text-base font-bold">
    <span className="flex items-center gap-2">
      <CropIcon className="shrink-0" cropName={crop.name ?? ""} />
      {crop.mark ? (
        <mark className="text-can-slate-blue-gray">{crop.name}</mark>
      ) : (
        <span>{crop.name}</span>
      )}
    </span>
    <span>{crop.harvestYear}</span>
  </h4>
);

const Price = ({
  tons,
  pricePerTon,
  currency,
}: {
  tons?: number;
  pricePerTon?: number;
  currency: Currency;
}) => (
  <p>
    <Trans>Hodnota celkem (nyní)</Trans>:{" "}
    {pricePerTon !== undefined && tons !== undefined
      ? currencyFormatter(currency).format(pricePerTon * tons)
      : null}{" "}
    |{" "}
    {pricePerTon !== undefined
      ? `${currencyFormatter(currency).format(pricePerTon)}/t`
      : "-"}
  </p>
);

CommodityCard.Available = Available;
CommodityCard.Price = Price;
CommodityCard.Stored = Stored;
CommodityCard.Title = Title;
CommodityCard.ProgressBar = ThreeStepProgressBar;

export { CommodityCard };
